module.exports = __webpack_public_path__ + "img/icon-partnership.f83a9b7f.png";